<template>
  <header-app back="" titlepage="یزد گیشه"></header-app>
  <v-main class="main" >
    <data-view></data-view>
  </v-main>
  <footer-app selectedItem="1"></footer-app>
</template>

<script>
import { defineComponent } from 'vue';

// Components
import HelloWorld from '../components/HelloWorld.vue';
import QrScaner from "@/components/QrSacner.vue";
import SansView from "@/views/SansView.vue";
import HeaderApp from "@/views/headerApp.vue";
import FooterApp from "@/views/FooterApp.vue";
import DataView from "@/views/DataView.vue";
import router from "@/router";

export default defineComponent({
  name: 'HomeView',

  components: {
    DataView,
    HeaderApp,
    SansView,
    QrScaner,
    HelloWorld,
    FooterApp
  },
  methods:{
    routerPush(link){
      router.push(link)
    }
  }
});
</script>
<style>
.v-main{
  background: #00a5a7;
}
.main{
  padding: 60px 0 60px;
  height: calc(100% +100px);
}
h2,h3{
  font-size: 12pt !important;
  text-align: center;
  padding: 5px;
  direction: rtl;

}
.col-6 div{
  width: 90%;
  margin: 10px auto;
  background: #e8e8e8;
  border-radius: 10px;
  border: 1px solid #bebebe;
}
</style>